import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { isEmpty } from 'rxjs';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { CreateFormatPalletStockRequest, FileStockColumn, FormatPalletStock, StockColumn, UpdateFormatPalletStock } from 'src/app/domain/models/PalletStock';
import { ErrorMessageUtil } from '../../util/error-message-util';
import { Lang } from '../../util/langs';

@Component({
  selector: 'app-create-pallet-stock-format',
  templateUrl: './create-pallet-stock-format.component.html',
  styleUrls: ['./create-pallet-stock-format.component.css']
})
export class CreatePalletStockFormatComponent implements OnInit, OnChanges {

  loading: boolean = false;

  stockColumns: StockColumn[] = []
  orderColumns: StockColumn[] = []

  @Input()
  formatName: string | undefined = "";
  submitFormatName: boolean = false

  submitColumnsForm: boolean = false

  emptyColumn: StockColumn = {
    id: 0,
    columnKey: 'empty',
    columnName: 'Empty',
    columnNameEs: 'Vacío',
    entityField: 'Empty',
    frontEntityField: 'empty',
    isPackingList: false
  }

  @Output()
  OnCreateFormat: EventEmitter<any> = new EventEmitter();

  @Output()
  OnCancelCreate:  EventEmitter<any> = new EventEmitter();

  @Input()
  headers: string[] = []

  fileColumnOptions: {label: string, value: string}[] = []
  stockColumnOptions: FileStockColumn[] = []
  fileStockMatchedColumns: FileStockColumn[] = []

  @Input()
  file: any

  deletedColumns: StockColumn[] = [];

  visibleDeletedColumns: boolean = false;
  visiblePreview: boolean = false;

  @Input()
  formatId: number | undefined

  buttonAction: string = "";

  constructor(
    private _router: Router,
    public translate: TranslateService,
    private _palletStockService: PalletStockGateway,
    private _messageService: MessageService,
    private _formBuilder: FormBuilder,
  )
  {

  }

  ngOnInit(): void {
      this.getColumns();
      this.setAction()
  }

  setAction()
  {

    this.translate.get([
      'CreatePalletStock.EditButtonLabel',
      'CreatePalletStock.SaveButtonLabel'
    ]).subscribe({
      next: (translations) => {
        if(this.formatId)
        {
          this.buttonAction = translations['CreatePalletStock.EditButtonLabel']
        }else{
          this.buttonAction = translations['CreatePalletStock.SaveButtonLabel']
        }
      }
    })


  }

  formatFormGroup: FormGroup = this._formBuilder.group({
    formatName: ['', Validators.required]
  })

  columnsFormGroup: FormGroup = this._formBuilder.group({
    fileColumn: ['', Validators.required],
    stockColumn: ['', Validators.required],
    columnOrder: [0]
  })


ngOnChanges(changes: SimpleChanges): void {
  if(changes['formatId'] || changes['formatName'])
  {
    this.getColumns()
    this.setAction()
  }

  if (changes['headers'] && this.headers && this.headers.length > 0) {
    this.headers.map((header) => {
      this.fileColumnOptions.push({
        label: header,
        value: header
      })
    })
    if (this.fileColumnOptions[0]?.value) {
      this.columnsFormGroup.patchValue({ fileColumn: this.fileColumnOptions[0].value })
    }
  }
}


  handleFormatPalletAction()
  {
    if(this.formatId)
    {
      this.editFormatPalletStock()
    }else{
      this.createFormatPalletStock()
    }
  }

  addFileStockMatchedEmptyColumns() {
    const fileStockMatchedColumns = [...this.fileStockMatchedColumns];
    this.fileColumnOptions.forEach((_) => {
      fileStockMatchedColumns.push({ ...this.emptyColumn })
    })
    return fileStockMatchedColumns
  }

  createFormatPalletStock()
  {
      let fileStockMatchedColumns: FileStockColumn[] = this.fileStockMatchedColumns;
      if (this.file) {
        fileStockMatchedColumns = this.addFileStockMatchedEmptyColumns();
      }

      this.submitFormatName = true
      if(this.formatFormGroup.valid)
      {
      this.loading = true;
      var request: CreateFormatPalletStockRequest = {
        columns: this.file ? fileStockMatchedColumns : this.orderColumns,
        formatName: this.formatFormGroup.controls['formatName'].value
      }

      this._palletStockService.createFormatPalletStock(request).subscribe({
        next: (v) => {
          this.loading = false
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.CreatePalletStockFormatSuccess') })
          this.getColumns()
          this.headers = [];
          this.OnCreateFormat.emit();
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.CreatePalletStockFormatError') })
        }
      })
    }
  }

  editFormatPalletStock()
  {
    this.submitFormatName = true;
    if(this.formatFormGroup.valid && this.formatId)
      {
      this.loading = true;
      var request: UpdateFormatPalletStock = {
        columns: this.orderColumns,
        formatName: this.formatFormGroup.controls['formatName'].value,
        formatId: this.formatId
      }

      this._palletStockService.updateFormatPalletStock(request).subscribe({
        next: (v) => {
          this.loading = false
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.UpdatePalletStockFormatSuccess') })
          this.getColumns()
          this.headers = [];
          this.OnCreateFormat.emit();
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.UpdatePalletStockFormatError') })
        }
      })
    }
  }

  getColumns()
  {
    this.stockColumns = []
    this.stockColumnOptions = []
    this.orderColumns = []
    this.deletedColumns = [];
    this.fileStockMatchedColumns = [];
    if(this.formatId)
    {
      this.onEditFormat(this.formatId);
    }else
    {
      this.getColumnsNewFormat();
    }
  }

  getColumnsNewFormat()
  {
    this.loading = true;
    this._palletStockService.getColumns().subscribe({
      next: (v) => {
        this.stockColumns = v;
        this.orderColumns = [...v];
        this.loading = false;
        this.stockColumnOptions = [ this.emptyColumn, ...v ]
        if (this.stockColumnOptions[1]?.columnKey) {
          this.columnsFormGroup.patchValue({ stockColumn: this.stockColumnOptions[1].columnKey })
        }
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
      }
    })
  }

  updateColumnOrder(event: any)
  {
    let { dragIndex, dropIndex } = event;
    let movedColumn = this.orderColumns.splice(dragIndex, 1)[0];
    this.orderColumns.splice(dropIndex, 0, movedColumn);
  }

  onCancelCreateAction()
  {
    this.getColumns()
    this.headers = [];
    this.OnCancelCreate.emit();
  }

  getErrorMessage(formGroup: FormGroup, fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(formGroup, this.translate, fieldName)
  }


  addEmptyColumn()
  {
    this.stockColumns.push({
      ...this.emptyColumn
    })

    this.orderColumns.push({
      ...this.emptyColumn
    })

    this.fileStockMatchedColumns.push({
      ...this.emptyColumn
    })
  }

  removeColumn(index: number, id: number)
  {
    let removeColumns = this.stockColumns.splice(index, 1);
    removeColumns.forEach(x => {
      if(x.id != 0)
      {
        this.deletedColumns.push(x);
      }
    })
    this.orderColumns.splice(index, 1);
  }

  AddRemoveColumn(index: number)
  {
    let removeColumns = this.deletedColumns.splice(index, 1);
    removeColumns.forEach(x => {
      this.stockColumns.push(x);
      this.orderColumns.push(x)
    })
  }

  visibleRemoveColumn()
  {
    if(this.deletedColumns.length > 0)
    {
      this.visibleDeletedColumns = true;
    }
  }

    onEditFormat(formatId: number)
  {
    this.getFormatColumns(formatId);
    this.getNotUsedColumns(formatId);
  }

  getFormatColumns(formatId: number)
  {
    this.loading = true;
    this._palletStockService.getFormatColumns(formatId).subscribe({
      next: (v) => {
        this.stockColumns = v;
        this.orderColumns = [...v];
        this.formatFormGroup.controls['formatName'].setValue(this.formatName);
        this.loading = false;
        this.stockColumnOptions = [ this.emptyColumn, ...v ]
        if (this.stockColumnOptions[1]?.columnKey) {
          this.columnsFormGroup.patchValue({ stockColumn: this.stockColumnOptions[1].columnKey })
        }
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetFormatColumnsError') })
      }
    })
  }

  getNotUsedColumns(formatId: number)
  {
    this.loading = true;
    this.deletedColumns = [];
    this._palletStockService.getUnUsedStockColumn(formatId).subscribe({
      next: (v) => {
        this.deletedColumns = v
        this.loading = false;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetFormatColumnsError') })
      }
    })
  }

  onVisiblePreview()
  {
    this.visiblePreview = true;
  }

  SendEmpty(position: number)
  {

    if(this.stockColumns.length - 1 >= position)
    {
      this.stockColumns.splice(position, 0,{
        ...this.emptyColumn
      })

      this.orderColumns.splice(position, 0,{
        ...this.emptyColumn
      })
    }

  }

  handleColumnOrder() {
    const currentOrder = this.columnsFormGroup.value.columnOrder;
    const tableColumns = [...this.fileStockMatchedColumns];

    // Encontrar objeto seleccionado en stockColumnOptions
    const selectedStockColumn = this.stockColumnOptions.find(c => c.columnKey === this.columnsFormGroup.value.stockColumn);
    let newElement: FileStockColumn = {
      ...selectedStockColumn!,
      id: selectedStockColumn?.columnKey === 'empty' ? 0 : selectedStockColumn?.id!,
      fileColumn: this.columnsFormGroup.value.fileColumn
    }

    // Si columnOrder es menor que la longitud actual, insertar en esa posición
    if (currentOrder < tableColumns.length) {
      tableColumns.splice(currentOrder, 0, newElement);
    }
    // Si columnOrder es mayor a la posición actual, rellenar con empty hasta esa posición
    else if (currentOrder > tableColumns.length) {
      const itemsToAdd = currentOrder - tableColumns.length;
      // Actualizar columnas archivos para eliminar elementos ya usados
      this.fileColumnOptions = this.fileColumnOptions.filter(h => h.value !== newElement.fileColumn);
      const addedItems: string[] = []

      for (let i = 0; i < itemsToAdd; i++) {
        if (this.fileColumnOptions[i] !== undefined) {
          tableColumns.push({
            ...this.emptyColumn,
            fileColumn: this.fileColumnOptions[i].value
          })
          addedItems.push(this.fileColumnOptions[i].value)
        }
      }
      this.fileColumnOptions = this.fileColumnOptions.filter(h => !addedItems.includes(h.value));
      tableColumns.push(newElement)
    }
    else {
      tableColumns.push(newElement)
    }

    this.fileStockMatchedColumns = tableColumns;
  }

  validateNewColumnOrder(currentOrder: number) {
    if (currentOrder < 0) {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('CreatePalletStock.ColumnOrderNegativeError') })
      return false;
    }
    else if (currentOrder > this.headers.length) {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('CreatePalletStock.ColumnOrderExceedsError', { length: this.fileColumnOptions.length }) })
      return false;
    }
    return true
  }

  onAddColumn() {
    if (!this.validateNewColumnOrder(this.columnsFormGroup.value.columnOrder)) return

    this.submitColumnsForm = true;

    if (this.columnsFormGroup.valid && this.fileColumnOptions.length > 0 && this.stockColumnOptions.length > 0) {
      this.handleColumnOrder();
      this.updateAvailableOptions();

      if (this.fileColumnOptions[0]?.value) {
        this.columnsFormGroup.get('fileColumn')?.setValue(this.fileColumnOptions[0].value);
      }
      if (this.stockColumnOptions.length > 1) {
        this.columnsFormGroup.get('stockColumn')?.setValue(this.stockColumnOptions[1].columnKey);
      }
      else {
        this.columnsFormGroup.get('stockColumn')?.setValue(this.stockColumnOptions[0].columnKey);
      }
      this.columnsFormGroup.get('columnOrder')?.setValue(this.fileStockMatchedColumns.length);
    }
  }

  updateAvailableOptions() {
    this.fileColumnOptions = this.fileColumnOptions.filter(h => h.value !== this.columnsFormGroup.value.fileColumn);

    if (this.columnsFormGroup.value.stockColumn !== 'empty') {
      this.stockColumnOptions = this.stockColumnOptions.filter(c => c.columnKey !== this.columnsFormGroup.value.stockColumn);
    }
  }

  removeFromSelectedColumns(index: number) {
    const deletedFileColumn = this.fileStockMatchedColumns[index].fileColumn;
    const deletedStockColumn = this.fileStockMatchedColumns[index];

    if (deletedStockColumn && deletedStockColumn.columnKey.toLowerCase() !== 'empty') {
      // Agregar las opciones eliminadas de nuevo a la lista de stockColumns
      this.stockColumnOptions.splice(1, 0, deletedStockColumn);
    }

    this.fileColumnOptions.unshift({ label: deletedFileColumn!, value: deletedFileColumn! });
    const tableColumns = [...this.fileStockMatchedColumns];
    tableColumns.splice(index, 1);

    // Actualizar listado y orden actual
    this.fileStockMatchedColumns = tableColumns;
    this.columnsFormGroup.patchValue({columnOrder: this.fileStockMatchedColumns.length})
  }

  ngOnDestroy(): void {
    this.headers = []
    this.stockColumnOptions = []
    this.fileStockMatchedColumns = []
    this.formatId = undefined
    this.formatName = ""
  }

  getItemDesc(stockColumn: StockColumn): string
  {
    var lang = this.translate.currentLang;
    var name = "";

    switch(lang)
    {
      case Lang.ENGLISH:
        name = stockColumn.columnName;
        break;
      case Lang.SPANISH:
        name = stockColumn.columnNameEs;
        break;
      default:
        name = stockColumn.columnName;
    }


    console.log("pASA");
    if(stockColumn.isPackingList == true)
    {
        name + "-Packing list"
    }

    return name;
  }
}
